/**
 * 根据Object拼接得到URL参数
 * @param {Object} params 需要拼接的参数
 * @param {String} joinChar 拼接的字符
 */
export const getUrlParamsByObject = (params = {},joinChar = '&') => {
  let paramsString = ''
  for (const key in params) {
    if (params.hasOwnProperty(key)) {
      paramsString = !paramsString
        ? `${key}=${params[key]}`
        : `${paramsString}${joinChar}${key}=${params[key]}`
    }
  }
  return paramsString
}

/**
 * 根据URL参数解析得到Object
 * @param {String} paramsString URL参数
 * @param {String} joinChar 拼接的字符
 */
export const getObjectByUrlParams = (paramsString,joinChar = '&') => {
  if (!paramsString) return null

  const params = {}
  const paramsArray = paramsString.split(joinChar)
  for (const item of paramsArray) {
    const itemArray = item.split('=')
    params[itemArray[0]] = itemArray[1] || ''
  }
  return params
}

/**
 * 拼接分享链接
 */
export const shareUrl = (path,options) => {
  // let paramsString = ''
  // for (const key in options) {
  //   if (options.hasOwnProperty(key)) {
  //     const element = options[key]
  //     paramsString = paramsString
  //       ? `${paramsString}&${key}=${element}`
  //       : `${paramsString}?${key}=${element}`
  //   }
  // }
  // return `${location.origin}${location.pathname}#/${path}${paramsString}`

  return `https://wecom-dev.digibridge.cn/decathlon_campaign/#/home`
}
